(function($, window) {
    this.imageControl = function(canvasId, canvasType) {
        line1_1 = ''
        line1_2 = ''
        line1_3 = ''
        line1_4 = ''
        line1_5 = ''
        line1_6 = ''
        line2 = ''
        line3 = ''
        line4_1 = ''
        line4_2 = ''
        line4_3 = ''
        points5_1 = ''
        path5_1 = ''
        line5_1 = ''
        points5_2 = ''
        path5_2 = ''
        line5_2 = ''
        points5_3 = ''
        path5_3 = ''
        line5_3 = ''

        $('#tooltip1').roundSlider({
            circleShape: 'custom-quarter',
            width: 25,
            radius: 200,
            value: 180,
            min: 0,
            max: 360,
            startAngle: 225,
            editableTooltip: false,
            tooltipFormat: function(args) {
                return (args.value - 180) + '°'
            },
            drag: function(args) {
                canvasChange()
                imgInstance.set({
                    originX: 'center',
                    originY: 'center',
                    angle: args.value - 180,
                })
                imgInstance.setCoords()
            },
            change: function(args) {
                canvasChange()
                imgInstance.set({
                    originX: 'center',
                    originY: 'center',
                    angle: args.value - 180,
                })
                imgInstance.setCoords()
                canvas2.renderAll()
            },
        })
        $('#tooltip1').roundSlider('disable')
        changeTooltipWidth()

        console.log('window resize register')
        $(window).resize(function(e) {
            console.log('window resize')
            if ($('#bd-wrapper').length > 0 && canvas2.wrapperEl) {
                changeTooltipWidth()
                // compute canvas zoom
                canvasZoom = $('#bd-wrapper').width() / canvasBaseWidth
                console.log('canvas2 setWidth', canvas2, canvasZoom, canvasBaseWidth)
                canvas2.setWidth(canvasBaseWidth * canvasZoom)
                canvas2.setHeight(getHeightRatio(canvasBaseWidth * canvasZoom))
                canvas2.setZoom(canvasZoom)
                console.log('canvas2 setAttribute')
                canvas.setAttribute('width', canvasBaseWidth * canvasZoom)
                canvas.setAttribute('height', getHeightRatio(canvasBaseWidth * canvasZoom))
                if (canvasType == 'smile') {
                    resetLineDimension()
                }
                canvas2.renderAll()
                var videoWidth = Math.floor(canvas2.getWidth() / 2 * videoZoomRate) + 'px'
                console.log(canvasVideo)
                canvasVideo.style.width = videoWidth
            }
        })

        // calculate line strokeWidth based on canvas zoom
        function resetLineDimension() {
            console.log('resetLineDimension')

            var obj = canvas2.getObjects()
            for (k in obj) {
                if (obj[k].name.indexOf('line1') !== -1 || obj[k].name == 'line2'
                    || obj[k].name.indexOf('line5_3') !== -1 || obj[k].name.indexOf('line5_3-') !== -1) {
                    obj[k].set({ 'strokeWidth': 2 / canvasZoom })
                } else if (obj[k].name.indexOf('line4') !== -1) {
                    obj[k].set({ 'strokeWidth': 2 / canvasZoom })
                } else if (obj[k].name == 'line5_1' || obj[k].name == 'line5_2'
                    || obj[k].name.indexOf('line5_1-') !== -1 || obj[k].name.indexOf('line5_2-') !== -1) {
                    obj[k].set({ 'strokeWidth': 2 / canvasZoom })
                } else if (obj[k].name == 'line3') {
                    obj[k].set({ 'strokeWidth': 2 / canvasZoom })
                }
            }
            computeLine2()
        }

        function changeTooltipWidth() {
            if (window.matchMedia('(min-width: 1400px)').matches) {
                $('#tooltip1').roundSlider('option', 'width', 25)
            } else {
                $('#tooltip1').roundSlider('option', 'width', 15)
            }
        }

        flipX = false
        flipXFunction = () => {
            if (hasImage) {
                canvasChange()
                flipX = !flipX
                imgInstance.set('flipX', flipX)
                canvas2.renderAll()
            }
        }

        flipY = false
        flipYFunction = () => {
            if (hasImage) {
                canvasChange()
                flipY = !flipY
                imgInstance.set('flipY', flipY)
                canvas2.renderAll()
            }
        }

        rotateRightFunction = () => {
            if (hasImage) {
                canvasChange()
                var imgRotate = imgInstance.get('angle') + 90
                setImageRotateTooltip(imgRotate)
                imgInstance.set({
                    originX: 'center',
                    originY: 'center',
                    angle: imgRotate,
                })
                canvas2.renderAll()
            }
        }

        rotateLeftFunction = () => {
            if (hasImage) {
                canvasChange()
                var imgRotate = imgInstance.get('angle') - 90
                setImageRotateTooltip(imgRotate)
                imgInstance.set({
                    originX: 'center',
                    originY: 'center',
                    angle: imgRotate,
                })
                canvas2.renderAll()
            }
        }

        function setImageRotateTooltip(imgRotate) {
            var rotate = 0
            var mod = Math.abs(imgRotate) % 360
            if (imgRotate >= 0) {
                rotate = mod <= 180 ? mod + 180 : mod - 180
            } else {
                var modReverse = 360 - mod
                rotate = mod <= 180 ? modReverse - 180 : modReverse + 180
            }
            $('#tooltip1').roundSlider('setValue', rotate)
        }

        trashFunction = () => {
            console.log('trashFunction')
            imgInstance = null
            canvas2.setZoom(canvasZoom)
            var objects = canvas2.getObjects('image')
            for (let i in objects) {
                canvas2.remove(objects[i])
            }
            // resetCanvas();
            canvas2.loadFromJSON(canvasOrigin, function() {
                var paths = canvas2.getObjects('path')
                for (let i in paths) {
                    canvas2.remove(paths[i])
                }
                restoreFrame(canvas2.getObjects())
                var points = {
                    points5_1: $.extend(true, [], baseGrid.points5_1),
                    points5_2: $.extend(true, [], baseGrid.points5_2),
                    points5_3: $.extend(true, [], baseGrid.points5_3),
                }
                restoreBezierLines(canvas2, points)
                baseScalePoints = $.extend(true, {}, originBaseScalePoints)
                canvasZoom = $('#bd-wrapper').width() / canvasBaseWidth
                canvas2.setWidth(canvasBaseWidth * canvasZoom)
                canvas2.setHeight(getHeightRatio(canvasBaseWidth * canvasZoom))
                canvas2.setZoom(canvasZoom)
                canvas.setAttribute('width', canvasBaseWidth * canvasZoom)
                canvas.setAttribute('height', getHeightRatio(canvasBaseWidth * canvasZoom))
                resetLineDimension()
                canvas2.renderAll()
            })
            // canvas2.renderAll();
            hasImage = false
            checkImgFunctions()
            canvasChange()
        }

        cloneCanvasRatio = () => {
            var canvasDownload = fabric.util.object.clone(canvas2)
            // canvas2.discardActiveObject();

            const canvasWidth = canvasDownload.getWidth()
            const canvasHeight = getHeightRatio(canvasWidth)
            canvasDownload.setHeight(canvasHeight)

            return canvasDownload
        }

        downloadFunction = (link, filename) => {
            var canvasDownload = cloneCanvasRatio()
            const canvasWidth = canvasDownload.getWidth()
            const canvasHeight = canvasDownload.getHeight()

            if (hasImage || hasVideo) {
                canvasDownload.backgroundColor = '#e8e8e8'
                canvasDownload.renderAll()
                if (canvasType == 'dsd') {
                    var videoWidth = Math.floor(canvasWidth / 2 * videoZoomRate)
                    var videoHeight = Math.floor(canvasHeight / 2 * videoZoomRate)
                    var scaleRate = videoWidth / canvasVideo.videoWidth / canvasZoom
                    var videoPadding = parseInt(link.getAttribute('videoPadding').replace('px', ''))
                    var leftV = canvasWidth / 2 / canvasZoom
                    var topV = (getHeightRatio(canvasWidth) - (videoHeight + videoPadding)) / canvasZoom

                    let pd = canvasHeight / canvasZoom
                    const top = (pd - canvasVideo.videoHeight * scaleRate) - (pd * 0.1)
                    console.log('top', top, topV)

                    var video = new fabric.Image(canvasVideo, {
                        width: canvasVideo.videoWidth,
                        height: canvasVideo.videoHeight,
                        originX: 'center',
                        originY: 'top',
                        selectable: false,
                        hasControls: false,
                        hasBorders: false,
                        scaleX: scaleRate,
                        scaleY: scaleRate,
                        left: leftV,
                        top: top,
                    })

                    console.log('canvas size', canvasWidth, canvasHeight, canvasZoom)
                    console.log('video size', videoWidth, videoHeight, videoZoom.value, videoZoomRate)
                    console.log('video position', leftV, top, videoPadding, scaleRate)
                    console.log('video info', video, canvasDownload)

                    canvasVideo.style.visibility = 'hidden'
                    canvasDownload.add(video)
                    canvasDownload.sendToBack(video)
                    canvasDownload.renderAll()
                }

                link.href = canvas.toDataURL('image/png')
                link.download = filename
                if (canvasType == 'dsd') {
                    canvasDownload.remove(canvasDownload.getObjects('image')[0]) // remove first image
                    canvasVideo.style.visibility = 'visible'
                }
                canvasDownload.backgroundColor = 'transparent'
                canvasDownload.renderAll()

            }
        }

        /*Zoom with canvas2 = fabric*/
        var imageRange = document.getElementById('image-range')
        imageRange.oninput = function() {
            zoomImg(this.value)
            canvasChange()
        }

        zoomImg = (value) => {
            var rate = value / 50
            imgInstance.set({
                originX: 'center',
                originY: 'center',
                scaleX: rate,
                scaleY: rate,
            })
            imgInstance.setCoords()
        }

        /* Video controler */
        var canvasVideo = document.getElementById('canvas-video')
        var videoTimeRange = document.getElementById('video-time-range')
        var videoPlaying = false
        var hasVideo = false
        var videoZoom = document.getElementById('video-range')
        var videoZoomRate = 1
        var imageBeforeErase = {}
        var imgTransparentControl = document.getElementById('img-transparent')

        videoPlay = () => {
            if (hasVideo) {
                if (canvasVideo.paused) {
                    canvasVideo.play()
                    videoPlaying = true
                    $('#video-play-control .video-btn-icon').attr('icon', 'fa-pause')
                } else {
                    canvasVideo.pause()
                    videoPlaying = false
                    $('#video-play-control .video-btn-icon').attr('icon', 'fa-play')
                }
                canvasChange()
            }
        }

        videoSkip = (value) => {
            let newTime = canvasVideo.currentTime + value
            if (canvasVideo.currentTime > canvasVideo.duration) newTime = canvasVideo.duration
            canvasVideo.currentTime = newTime
            canvasChange()
        }

        // Event listener for videoZoom change input
        videoZoom.oninput = function() {
            zoomVideo(this.value)
        }

        zoomVideo = (value) => {
            videoZoomRate = videoZoom.value / 50
            var videoWidth = Math.floor(canvas2.getWidth() / 2 * videoZoomRate) + 'px'
            canvasVideo.style.width = videoWidth
            canvasChange()
        }


        // Event listener for videoTimeRange change input
        videoTimeRange.oninput = function() {
            var time = canvasVideo.duration * (videoTimeRange.value / 100)
            canvasVideo.currentTime = time
            canvasChange()
        }

        // Update videoTimeRange as video plays
        canvasVideo.addEventListener('timeupdate', function() {
            var value = (100 / canvasVideo.duration) * canvasVideo.currentTime
            if (!value) value = 0
            videoTimeRange.value = value
        })

        // Handle width video end
        canvasVideo.addEventListener('ended', function() {
            videoPlaying = false
            $('#video-play-control .video-btn-icon').attr('icon', 'fa-play')
        }, false)

        // Pause the video when videoTimeRange handle is being dragged
        videoTimeRange.addEventListener('mousedown', function() {
            canvasVideo.pause()
        })

        // Play the video when videoTimeRange handle is dropped
        videoTimeRange.addEventListener('mouseup', function() {
            if (videoPlaying) {
                canvasVideo.play()
            }
        })

        // making navigator.getUserMedia cross-browser compatible
        function getUserMedia() {
            var userMediaFunc = navigator.getUserMedia || navigator.webkitGetUserMedia || navigator.mozGetUserMedia || navigator.msGetUserMedia
            if (userMediaFunc) userMediaFunc.apply(navigator, arguments)
        }

        // fabric.util.requestAnimFrame(function render() {
        //     canvas2.renderAll();
        //     fabric.util.requestAnimFrame(render);
        // });

        updateScaleVideo = (value) => {
            if (hasVideo) {
                var range = document.getElementById('video-range')
                range.value = Number(range.value) + value
                zoomVideo(range.value)
            }
        }

        updateScaleImg = (value) => {
            if (hasImage) {
                var range = document.getElementById('image-range')
                range.value = Number(range.value) + value
                zoomImg(range.value)

                canvas2.renderAll()
            }
        }

        updateTransparent = (value) => {
            if (hasImage) {
                if (imgTransparentControl.value > 0 || imgTransparentControl.value < 100) {
                    imgTransparentControl.value = Number(imgTransparentControl.value) + value
                    imgInstance.set({
                        opacity: imgTransparentControl.value / 100,
                    })

                }
            }
            canvasChange()
        }

        imgTransparentControl.oninput = function() {
            canvasChange()

            imgInstance.set({
                opacity: imgTransparentControl.value / 100,
            })
        }

        /* Drawline fabric*/
        var canvas = document.getElementById('canvas-item')
        canvas.setAttribute('width', $('#bd-wrapper').width())
        canvas.setAttribute('height', Math.round($('#bd-wrapper').width() * 720 / 1280))
        var canvas2 = new fabric.Canvas(canvasId, {
            width: $('#bd-wrapper').width(),
            height: Math.round($('#bd-wrapper').width() * 720 / 1280),
            backgroundColor: 'transparent',
            preserveObjectStacking: true,
            selection: false,
            objectCaching: false,
        })
        var canvasBaseWidth = canvas2.getWidth()
        var canvasBaseHeight = canvas2.getHeight()
        var mouse = {}
        var lastMouse = {}
        var pts = []
        var hasEraseImg = false
        var hasImage = false
        var imageOriginDimension = {}
        var imgInstance

        /* handle width uploading image */
        var imageLoader = document.getElementById('imageLoader')
        imageLoader.addEventListener('change', handleInputFile, false)
        var imageLoader2 = document.getElementById('imageLoader2')
        imageLoader2.addEventListener('change', handleInputFile, false)

        var fileArea = document.getElementById('canvas-file-input');
        ['dragenter', 'dragover', 'dragleave', 'drop'].forEach(eventName => {
            fileArea.addEventListener(eventName, preventDefaults, false)
        })

        function preventDefaults(e) {
            e.preventDefault()
            e.stopPropagation()
        }

        fileArea.addEventListener('drop', handleDrop, false)

        function handleDrop(e) {
            var files = {
                target: {
                    files: e.dataTransfer.files,
                },
            }
            handleInputFile(files)
        }

        function handleInputFile(e) {
            console.log('handleInputFile', e)
            canvas2.setZoom(canvasZoom)
            var fileType = e.target.files.length > 0 ? e.target.files[0]['type'] : ''
            if (fileType.indexOf('image') !== -1) {
                var reader = new FileReader()
                reader.onload = function(event) {
                    var img = new Image()
                    // var dataURL = reader.result;
                    img.onload = function() {
                        if (imgInstance) {
                            canvas2.remove(imgInstance)
                            checkImgFunctions(false)
                        }

                        // reduce image size
                        var imgRate = img.width / img.height
                        var src = imageToDataUri(img, 4000, Math.round(4000 / imgRate))
                        fabric.Image.fromURL(src, function(img2) {
                            imageOriginDimension = {
                                width: img2.width,
                                height: img2.height,
                            }

                            imgInstance = img2.set({
                                originX: 'center',
                                originY: 'center',
                                hasBorders: false,
                                selectable: true,
                                hasControls: false,
                                name: 'background',
                                opacity: 1,
                                objectCaching: false,
                            })

                            canvas2.add(imgInstance)
                            // canvas2.centerObject(imgInstance);
                            canvas2.viewportCenterObject(imgInstance)
                            canvas2.sendToBack(imgInstance)
                            canvas2.renderAll()
                            imageBeforeErase = $.extend(true, {}, imgInstance)
                            // compute white_frame scale dimenstion
                            if (canvasType != 'dsd') {
                                maxScaleX = (canvas2.getHeight() - 20) / white_frame.height
                                maxScaleY = (canvas2.getHeight() - 20) / white_frame.height
                                minScaleX = 0.5
                                minScaleY = 0.5
                                var zoom = (maxScaleY - minScaleY) / 100 * 50 + minScaleY
                                white_frame.scaleX = zoom
                                white_frame.scaleY = zoom
                                zoomGrid()
                            }
                            hasImage = true
                            checkImgFunctions(true)
                            checkVideoFunctions(hasVideo)
                            canvasChange()
                            // remove lines and remove mode
                            if (canvasType == 'dsd') {
                                removeAllLine()
                                canvas2.renderAll()
                                pts = []
                                hasEraseImg = false
                                allowRemoveArea = false
                                var removeBtn = document.getElementById('remove-area-btn')
                                removeBtn.classList.remove('active')
                            }
                        })
                    }
                    img.src = event.target.result
                    window.uploadImageSrc = event.target.result

                }
                reader.readAsDataURL(e.target.files[0])
            } else if (canvasType == 'dsd' && fileType.indexOf('video') !== -1) {
                console.log(222, 'upload video')

                checkVideoFunctions(false)
                canvasVideo.innerHTML = ''
                var fileURL = URL.createObjectURL(e.target.files[0])
                var source = document.createElement('source')
                window.uploadVideoSrc = fileURL
                source.setAttribute('src', fileURL)
                canvasVideo.appendChild(source)
                canvasVideo.load()
                hasVideo = true
                checkVideoFunctions(true)
                checkImgFunctions(hasImage)
                canvasChange()
            }
            imageLoader.value = ''
            imageLoader2.value = ''
        }

        function imageToDataUri(img, width, height) {
            // create an off-screen canvas
            var canvas = document.createElement('canvas'),
                ctx = canvas.getContext('2d')
            // set its dimension to target size
            canvas.width = width
            canvas.height = height
            // draw source image into the off-screen canvas:
            ctx.drawImage(img, 0, 0, width, height)
            // encode image to data-uri with base64 version of compressed image
            return canvas.toDataURL('image/jpeg')
        }

        function checkImgFunctions(hasImage) {
            if (hasImage) {
                imageRange.disabled = false
                imgTransparentControl.disabled = false
                document.getElementById('frame-range').disabled = false
                $('#tooltip1').roundSlider('enable')
                setImageRotateTooltip(imgInstance.get('angle'))
            } else {
                imageRange.disabled = true
                imageRange.value = 50
                imgTransparentControl.disabled = true
                imgTransparentControl.value = 100
                document.getElementById('frame-range').disabled = true
                setImageRotateTooltip(0)
                $('#tooltip1').roundSlider('disable')
            }
        }

        function checkVideoFunctions(hasVideo) {
            if (hasVideo) {
                videoZoom.disabled = false
                videoTimeRange.disabled = false
            } else {
                videoZoom.disabled = true
                videoZoom.value = 50
                zoomVideo(50)
                videoZoomRate = 1
                videoTimeRange.disabled = true
            }
        }

        function addCanvasObjects() {
            canvas2.add(white_frame)
            canvas2.add(line4_1)
            canvas2.add(line4_2)
            canvas2.add(line4_3)
            canvas2.add(line3)
            canvas2.add(line1_1)
            canvas2.add(line1_2)
            canvas2.add(line1_3)
            canvas2.add(line1_4)
            canvas2.add(line1_5)
            canvas2.add(line1_6)
            canvas2.add(line2)
            canvas2.add(line5_1)
            canvas2.add(line5_2)
            canvas2.add(line5_3)
            createCircles(points5_1, 'line5_1', '#57b6e2')
            createCircles(points5_2, 'line5_2', '#57b6e2')
            createCircles(points5_3, 'line5_3', '#5b8440')
        }

        function resetDimensionBezier(line) {
            console.log('resetDimensionBezier', line)
            var dims = line._parseDimensions()
            line.width = dims.width
            line.height = dims.height
            line.pathOffset.x = line.width / 2
            line.pathOffset.y = line.height / 2
            line.setCoords()
        }

        var baseScalePoints = {}

        function createCircles(points, pre_name, stroke) {
            points.forEach(function(point, index) {
                var name = pre_name + '-' + index
                var circle = new fabric.Circle({
                    objectCaching: false,
                    radius: 5,
                    fill: 'white',
                    left: point.x,
                    top: point.y,
                    originX: 'center',
                    originY: 'center',
                    hasBorders: false,
                    hasControls: false,
                    strokeWidth: 3,
                    stroke: stroke,
                    name: name,
                })
                canvas2.add(circle)
                baseScalePoints[name] = {
                    left: (point.x - white_frame.left) / white_frame.scaleX,
                    top: (point.y - white_frame.top) / white_frame.scaleY,
                }
            })
        }

        // convert path string to array width each element contain 7 child element
        function pathStringToArray(path) {
            var arr = path.split(' ')
            for (let i in arr) {
                if (arr[i] != 'M' && arr[i] != 'Q') {
                    arr[i] = Number(arr[i])
                }
            }
            let result = [
                ['M', arr[1], arr[2]],
                ['Q', arr[4], arr[5], arr[6], arr[7]],
                ['Q', arr[8], arr[9], arr[10], arr[11]],
            ]
            return result
        }

        function pointToPathString(points, linePos, cubic_value) {
            var initPoints = $.extend(true, [], points)
            for (let i in initPoints) {
                initPoints[i].x -= linePos.left
                initPoints[i].y -= linePos.top
            }
            var bezierPoints = $.extend(true, [], initPoints)
            var t_cubic = cubic_value
            bezierPoints[1].x = Math.round((initPoints[1].x - t_cubic * t_cubic * initPoints[2].x - (1 - t_cubic) * (1 - t_cubic) * initPoints[0].x) / 2 / (1 - t_cubic) / t_cubic)
            bezierPoints[1].y = Math.round((initPoints[1].y - t_cubic * t_cubic * initPoints[2].y - (1 - t_cubic) * (1 - t_cubic) * initPoints[0].y) / 2 / (1 - t_cubic) / t_cubic)
            bezierPoints[3].x = Math.round((initPoints[3].x - t_cubic * t_cubic * initPoints[4].x - (1 - t_cubic) * (1 - t_cubic) * initPoints[2].x) / 2 / (1 - t_cubic) / t_cubic)
            bezierPoints[3].y = Math.round((initPoints[3].y - t_cubic * t_cubic * initPoints[4].y - (1 - t_cubic) * (1 - t_cubic) * initPoints[2].y) / 2 / (1 - t_cubic) / t_cubic)
            var path = 'M ' + bezierPoints[0].x + ' ' + bezierPoints[0].y + ' Q'
            bezierPoints.forEach(function(point, index) {
                if (index != 0) {
                    path += ' ' + point.x + ' ' + point.y
                }
            })
            return path
        }

        // update quadratic line when change points by a value ( temporary or actual)
        function updateBezierLine(x_diff, y_diff, points, line, tmp) {
            var pointsTmp = []
            if (tmp) { //temporary
                pointsTmp = $.extend(true, [], points)
            } else {
                pointsTmp = points
            }
            for (let i in pointsTmp) {
                pointsTmp[i].x += x_diff
                pointsTmp[i].y += y_diff
            }
            line.path = pathStringToArray(pointToPathString(pointsTmp, line, 0.5))
            resetDimensionBezier(line)
        }

        // calculate all frame points based on center point
        function initialGrid(frameCenterX, frameCenterY, frameDiffW, frameDiffH, scaleX, scaleY) {
            var scaleX = scaleX
            var scaleY = scaleY
            if (!scaleX) {
                scaleX = 1
            }
            if (!scaleY) {
                scaleY = 1
            }
            var grid = {
                white_frame: {
                    width: 560 * scaleX,
                    height: 400 * scaleY,
                    left: frameCenterX,
                    top: frameCenterY,
                },
                line3: [
                    frameCenterX - 330 * scaleX, // x1
                    frameCenterY, // y1
                    frameCenterX + 330 * scaleX, // x2
                    frameCenterY, // y2
                ],
                line4_1: [
                    frameCenterX - 165 * scaleX, -2000,
                    frameCenterX - 165 * scaleX,
                    2000,
                ],
                line4_2: [
                    frameCenterX - 1, -2000,
                    frameCenterX - 1,
                    2000,
                ],
                line4_3: [
                    frameCenterX + 165 * scaleX, -2000,
                    frameCenterX + 165 * scaleX,
                    2000,
                ],
                line1_1: [
                    frameCenterX - 180 * scaleX,
                    frameCenterY - 200 * scaleY,
                    frameCenterX - 180 * scaleX,
                    frameCenterY + 100 * scaleY,
                ],
                line1_2: [
                    frameCenterX - 150 * scaleX,
                    frameCenterY - 200 * scaleY,
                    frameCenterX - 150 * scaleX,
                    frameCenterY + 100 * scaleY,
                ],
                line1_3: [
                    frameCenterX - 120 * scaleX,
                    frameCenterY - 200 * scaleY,
                    frameCenterX - 120 * scaleX,
                    frameCenterY + 100 * scaleY,
                ],
                line1_4: [
                    frameCenterX + 120 * scaleX,
                    frameCenterY - 200 * scaleY,
                    frameCenterX + 120 * scaleX,
                    frameCenterY + 100 * scaleY,
                ],
                line1_5: [
                    frameCenterX + 150 * scaleX,
                    frameCenterY - 200 * scaleY,
                    frameCenterX + 150 * scaleX,
                    frameCenterY + 100 * scaleY,
                ],
                line1_6: [
                    frameCenterX + 180 * scaleX,
                    frameCenterY - 200 * scaleY,
                    frameCenterX + 180 * scaleX,
                    frameCenterY + 100 * scaleY,
                ],
                line2: [
                    frameCenterX - 180 * scaleX,
                    frameCenterY + 100 * scaleY,
                    frameCenterX + 182 * scaleX,
                    frameCenterY + 100 * scaleY,
                ],
                points5_1: [
                    { x: frameCenterX - 212 * scaleX, y: frameCenterY - 20 * scaleY },
                    { x: frameCenterX - 90 * scaleX, y: frameCenterY + 18 * scaleY },
                    { x: frameCenterX, y: frameCenterY + 30 * scaleY },
                    { x: frameCenterX + 90 * scaleX, y: frameCenterY + 18 * scaleY },
                    { x: frameCenterX + 212 * scaleX, y: frameCenterY - 20 * scaleY },
                ],
                points5_2: [
                    { x: frameCenterX - 212 * scaleX, y: frameCenterY - 10 * scaleY },
                    { x: frameCenterX - 60 * scaleX, y: frameCenterY + 48 * scaleY },
                    { x: frameCenterX, y: frameCenterY + 62 * scaleY },
                    { x: frameCenterX + 60 * scaleX, y: frameCenterY + 48 * scaleY },
                    { x: frameCenterX + 212 * scaleX, y: frameCenterY - 10 * scaleY },
                ],
                points5_3: [
                    { x: frameCenterX - 212 * scaleX, y: frameCenterY + 20 * scaleY },
                    { x: frameCenterX - 60 * scaleX, y: frameCenterY + 78 * scaleY },
                    { x: frameCenterX, y: frameCenterY + 92 * scaleY },
                    { x: frameCenterX + 60 * scaleX, y: frameCenterY + 78 * scaleY },
                    { x: frameCenterX + 212 * scaleX, y: frameCenterY + 20 * scaleY },
                ],
            }
            return grid
        }

        var baseGrid = initialGrid(canvas2.getWidth() / 2, canvas2.getHeight() / 2, 0, 0, 1, 1) // initial grid at center of canvas

        // white frame
        white_frame = new fabric.Rect({
            width: baseGrid.white_frame.width,
            height: baseGrid.white_frame.height,
            strokeWidth: 3,
            top: baseGrid.white_frame.top,
            left: baseGrid.white_frame.left,
            // lockScalingFlip: true,
            hasRotatingPoint: false,
            name: 'white_frame',
            fill: 'rgba(0,0,0,0)',
            centeredScaling: true,
            originX: 'center',
            originY: 'center',
        })
        white_frame.on('scaling', scaleFrame)

        function scaleFrame(e) {
            // if (this.scaleX > maxScaleX) {
            //     this.scaleX = maxScaleX;
            //     this.left = this.lastGoodLeft;
            //     this.top = this.lastGoodTop;
            // }
            // if (this.scaleY > maxScaleY) {
            //     this.scaleY = maxScaleY;
            //     this.left = this.lastGoodLeft;
            //     this.top = this.lastGoodTop;
            // }
            // min scale
            if (this.scaleX < minScaleX) {
                this.scaleX = minScaleX
                this.left = this.lastGoodLeft
                this.top = this.lastGoodTop
            }
            if (this.scaleY < minScaleY) {
                this.scaleY = minScaleY
                this.left = this.lastGoodLeft
                this.top = this.lastGoodTop
            }
            this.lastGoodTop = this.top
            this.lastGoodLeft = this.left
            zoomGrid()
            var zoomValue = (this.scaleY - minScaleY) * 100 / (maxScaleY - minScaleY)
            document.getElementById('frame-range').value = zoomValue
        }

        // line 1
        line1_1 = new fabric.Line(baseGrid.line1_1, {
            stroke: '#70AD47',
            strokeWidth: 2,
            lockMovementY: true, //2
            lockRotation: true,
            hasBorders: false,
            hasControls: false,
            name: 'line1_1',
        })

        line1_2 = new fabric.Line(baseGrid.line1_2, {
            stroke: '#70AD47',
            strokeWidth: 2,
            lockMovementY: true,
            lockRotation: true,
            hasBorders: false,
            hasControls: false,
            name: 'line1_2',
        })

        line1_3 = new fabric.Line(baseGrid.line1_3, {
            stroke: '#70AD47',
            strokeWidth: 2,
            lockMovementY: true,
            lockRotation: true,
            hasBorders: false,
            hasControls: false,
            name: 'line1_3',
        })

        line1_4 = new fabric.Line(baseGrid.line1_4, {
            stroke: '#70AD47',
            strokeWidth: 2,
            lockMovementY: true,
            lockRotation: true,
            hasBorders: false,
            hasControls: false,
            name: 'line1_4',
        })

        line1_5 = new fabric.Line(baseGrid.line1_5, {
            stroke: '#70AD47',
            strokeWidth: 2,
            lockMovementY: true,
            lockRotation: true,
            hasBorders: false,
            hasControls: false,
            name: 'line1_5',
        })

        line1_6 = new fabric.Line(baseGrid.line1_6, {
            stroke: '#70AD47',
            strokeWidth: 2,
            lockMovementY: true,
            lockRotation: true,
            hasBorders: false,
            hasControls: false,
            name: 'line1_6',
        })

        // line 2
        line2 = new fabric.Line(baseGrid.line2, {
            stroke: '#70AD47',
            strokeWidth: 2,
            lockMovementX: true,
            lockRotation: true,
            hasBorders: false,
            hasControls: false,
            name: 'line2',
        })

        // line 3
        line3 = new fabric.Line(baseGrid.line3, {
            stroke: '#E846AE',
            strokeWidth: 2,
            lockMovementX: true,
            lockRotation: true,
            lockScalingY: true,
            hasBorders: false,
            hasControls: false,
            name: 'line3',
        })

        // line 4
        line4_1 = new fabric.Line(baseGrid.line4_1, {
            stroke: 'red',
            strokeWidth: 2,
            lockMovementY: true,
            lockRotation: true,
            lockScalingY: true,
            hasBorders: false,
            hasControls: false,
            name: 'line4_1',
        })

        line4_2 = new fabric.Line(baseGrid.line4_2, {
            stroke: 'red',
            strokeWidth: 2,
            lockMovementY: true,
            lockRotation: true,
            lockScalingY: true,
            hasBorders: false,
            hasControls: false,
            name: 'line4_2',
        })

        line4_3 = new fabric.Line(baseGrid.line4_3, {
            stroke: 'red',
            strokeWidth: 2,
            lockMovementY: true,
            lockRotation: true,
            lockScalingY: true,
            hasBorders: false,
            hasControls: false,
            name: 'line4_3',
        })

        points5_1 = $.extend(true, [], baseGrid.points5_1)
        path5_1 = pointToPathString(points5_1, { left: points5_1[0].x, top: points5_1[0].y }, 0.5)
        line5_1 = new fabric.Path(path5_1, {
            objectCaching: false,
            selectable: false,
            hasBorders: false,
            hasControls: false,
            name: 'line5_1',
            left: points5_1[0].x,
            top: points5_1[0].y,
            stroke: '#00a0ea',
            strokeWidth: 2,
            fill: false,
            evented: false,
            centeredScaling: true,
        })
        resetDimensionBezier(line5_1)

        points5_2 = $.extend(true, [], baseGrid.points5_2)
        path5_2 = pointToPathString(points5_2, { left: points5_2[0].x, top: points5_2[0].y }, 0.5)
        line5_2 = new fabric.Path(path5_2, {
            objectCaching: false,
            selectable: false,
            hasBorders: false,
            hasControls: false,
            name: 'line5_2',
            left: points5_2[0].x,
            top: points5_2[0].y,
            stroke: '#00a0ea',
            strokeWidth: 2,
            fill: false,
            evented: false,
            centeredScaling: true,
        })
        resetDimensionBezier(line5_2)

        points5_3 = $.extend(true, [], baseGrid.points5_3)
        path5_3 = pointToPathString(points5_3, { left: points5_3[0].x, top: points5_3[0].y }, 0.5)
        line5_3 = new fabric.Path(path5_3, {
            objectCaching: false,
            selectable: false,
            hasBorders: false,
            hasControls: false,
            name: 'line5_3',
            left: points5_3[0].x,
            top: points5_3[0].y,
            stroke: '#70ad47',
            strokeWidth: 2,
            fill: false,
            evented: false,
            centeredScaling: true,
        })
        resetDimensionBezier(line5_3)

        // calculate base point of each line to scale
        calculateBaseLinePoints(baseGrid)

        // properties should exist in json
        var stateProperties = (
            'name aCoords oCoords top left width height scaleX scaleY flipX flipY originX originY transformMatrix ' +
            'stroke strokeWidth strokeDashArray strokeLineCap strokeLineJoin strokeMiterLimit hasBorders hasControls hasRotatingPoint ' +
            'angle opacity fill fillRule globalCompositeOperation shadow clipTo visible backgroundColor radius objectCaching' +
            'alignX alignY meetOrSlice skewX skewY selectable lockMovementX lockMovementY centeredScaling lockScalingX lockScalingY lockScalingFlip lockUniScaling lockRotation'
        ).split(' ')
        var canvasOrigin = ''
        if (canvasType != 'dsd') {
            addCanvasObjects()
            originBaseScalePoints = $.extend(true, {}, baseScalePoints)
            // canvas2.calcOffset();
            canvas2.renderAll()
            // visibleAllObjects(false);
            canvasOrigin = JSON.stringify(canvas2.toJSON(stateProperties))
        }

        function calculateBaseLinePoints(grid) {
            let k
            for (k in grid) {
                if (grid.hasOwnProperty(k) && k.indexOf('line') !== -1) {
                    baseScalePoints[k] = {
                        left: baseGrid[k][0] - white_frame.left,
                        top: baseGrid[k][1] - white_frame.top,
                    }
                }
            }
        }

        function onBeforeSelectionCleared(e) {
            var activeObject = e.target
            if (activeObject.name == 'p0' || activeObject.name == 'p2') {
                activeObject.line2.animate('opacity', '0', {
                    duration: 200,
                    onChange: canvas2.renderAll.bind(canvas2),
                })
                activeObject.line2.selectable = false
            } else if (activeObject.name == 'p1') {
                activeObject.animate('opacity', '0', {
                    duration: 200,
                    onChange: canvas2.renderAll.bind(canvas2),
                })
                activeObject.selectable = false
            }
            var activeObj = canvas2.getActiveObject()
        }

        function drawLinesWhenDrag(obj) {
            var line_name = obj.name.split('-')[0]
            var pos = obj.name.split('-')[1]
            var line = {}
            var points = []
            switch (line_name) { // line name
                case 'line5_1':
                    line = line5_1
                    points = points5_1
                    break
                case 'line5_2':
                    line = line5_2
                    points = points5_2
                    break
                case 'line5_3':
                    line = line5_3
                    points = points5_3
                    break
                default:
                    console.log('default')
            }
            points[pos].x = obj.left
            points[pos].y = obj.top
            line.path = pathStringToArray(pointToPathString(points, line, 0.5))
            resetDimensionBezier(line)
            canvas2.renderAll()
        }

        canvas2.on({
            'object:moving': onObjectMoving,
            'object:moved': onObjectMoved,
            'object:modified': onObjectModified,
            'before:selection:cleared': onBeforeSelectionCleared,
            'mouse:down': onMouseDown,
            'mouse:up': onMouseUp,
            'mouse:move': onMouseMove,
        })

        function onObjectModified(e) {
            canvasChange()
        }

        function canvasChange() {
            window['canvasChange'] = true
        }

        var dragBezierLine = {}
        var dragBezierLineName = ''
        var dragBezierPoints = []
        var clickPoint = {}
        var updateQuadraticLine = false
        var selectedObj = {}
        var bezierMoveX = 0
        var bezierMoveY = 0
        var previousMouse = {}

        function onMouseDown(e) {
            if (canvasType != 'dsd') {
                previousMouse = { x: e.e.offsetX, y: e.e.offsetY }
                var activeObj = canvas2.getActiveObject()
                if (activeObj && activeObj.type == 'circle') {
                    activeObj.set('stroke', '#a4aab3')
                } else if (activeObj && activeObj.type != 'circle') {
                    lockMovement(activeObj)
                }
                objectMoveX = 0
                objectMoveY = 0
                bezierMoveX = 0
                bezierMoveY = 0
                if (!canvas2.getActiveObject() || (canvas2.getActiveObject() && canvas2.getActiveObject().get('type') != 'circle')) { // check if clicked point not in any circle
                    clickPoint = $.extend(true, {}, e.pointer)
                    clickPoint = {
                        x: clickPoint.x / canvasZoom,
                        y: clickPoint.y / canvasZoom,
                    }
                    var lieIn = false
                    if (isInBezier(points5_1, clickPoint)) {
                        lieIn = true
                        dragBezierLine = line5_1
                        dragBezierPoints = points5_1
                        dragBezierLineName = 'line5_1'
                        line5_1.set({ 'stroke': '#a4aab3', 'strokeWidth': 4 / canvasZoom })
                    } else if (isInBezier(points5_2, clickPoint)) {
                        lieIn = true
                        dragBezierLine = line5_2
                        dragBezierPoints = points5_2
                        dragBezierLineName = 'line5_2'
                        line5_2.set({ 'stroke': '#a4aab3', 'strokeWidth': 4 / canvasZoom })
                    } else if (isInBezier(points5_3, clickPoint)) {
                        lieIn = true
                        dragBezierLine = line5_3
                        dragBezierPoints = points5_3
                        dragBezierLineName = 'line5_3'
                        line5_3.set({ 'stroke': '#a4aab3', 'strokeWidth': 4 / canvasZoom })
                    }
                    if (lieIn && canvas2.getActiveObject()) {
                        selectedObj = canvas2.getActiveObject()
                        selectedObj.lockMovementY = true
                        selectedObj.lockMovementX = true
                        updateQuadraticLine = true
                    } else if (lieIn && !canvas2.getActiveObject()) {
                        updateQuadraticLine = true
                    } else if (!lieIn && activeObj && (activeObj.type == 'line' || activeObj.type == 'path')) {
                        activeObj.set({ 'stroke': '#a4aab3', 'strokeWidth': 4 / canvasZoom })
                    }
                }
            }
        }

        function lockMovement(obj) {
            if (obj.name == 'line2' && obj.name == 'line3') {
                obj.lockMovementX = true
            } else if (obj.name.indexOf('line1') !== -1 || obj.name.indexOf('line4') !== -1) {
                obj.lockMovementY = true
            }
        }

        function onMouseMove(e) {
            if (canvasType != 'dsd' && JSON.stringify(dragBezierLine) != '{}') {
                const moveX = (e.e.offsetX - previousMouse.x) / canvasZoom
                const moveY = (e.e.offsetY - previousMouse.y) / canvasZoom
                previousMouse = { x: e.e.offsetX, y: e.e.offsetY }
                bezierMoveX += moveX
                bezierMoveY += moveY
                // update points
                var points = $.extend(true, [], dragBezierPoints)
                var circles = canvas2.getObjects('circle')
                for (let i in points) {
                    points[i].x += bezierMoveX
                    points[i].y += bezierMoveY
                    var point_name = dragBezierLineName + '-' + i
                    var found = circles.findIndex(function(e) {
                        return e.name == point_name
                    })
                    circles[found].left = points[i].x
                    circles[found].top = points[i].y
                    circles[found].setCoords()
                }
                // redraw quadratic line
                dragBezierLine.path = pathStringToArray(pointToPathString(points, dragBezierLine, 0.5))
                resetDimensionBezier(dragBezierLine)
            }
        }

        function onMouseUp(e) {
            if (canvasType != 'dsd') {
                resetSmileColor()
                if (updateQuadraticLine == true) {
                    if (JSON.stringify(dragBezierLine) != '{}') {
                        var points = dragBezierPoints
                        for (let i in points) {
                            points[i].x += bezierMoveX
                            points[i].y += bezierMoveY
                            var pointName = dragBezierLineName + '-' + i
                            baseScalePoints[pointName] = { // calculate base zoom point
                                left: (points[i].x - white_frame.left) / white_frame.scaleX,
                                top: (points[i].y - white_frame.top) / white_frame.scaleY,
                            }
                        }
                        // reset drag value
                        selectedObj.lockMovementY = false
                        selectedObj.lockMovementX = false
                        dragBezierLine = {}
                        dragBezierPoints = []
                        clickPoint = {}
                        dragBezierLineName = ''
                    } else {
                        updateBezierLine(objectMoveX, objectMoveY, points5_1, line5_1, false)
                        updateBezierLine(objectMoveX, objectMoveY, points5_2, line5_2, false)
                        updateBezierLine(objectMoveX, objectMoveY, points5_3, line5_3, false)
                    }
                    updateQuadraticLine = false
                }
            }
            canvasChange()
        }

        function resetSmileColor() {
            var obj = canvas2.getObjects()
            for (k in obj) {
                if (obj[k].name.indexOf('line1') !== -1 || obj[k].name == 'line2'
                    || obj[k].name.indexOf('line5_3') !== -1 || obj[k].name.indexOf('line5_3-') !== -1) {
                    obj[k].set({ 'stroke': '#70AD47', 'strokeWidth': 2 / canvasZoom })
                } else if (obj[k].name.indexOf('line4') !== -1) {
                    obj[k].set({ 'stroke': 'red', 'strokeWidth': 2 / canvasZoom })
                } else if (obj[k].name == 'line5_1' || obj[k].name == 'line5_2'
                    || obj[k].name.indexOf('line5_1-') !== -1 || obj[k].name.indexOf('line5_2-') !== -1) {
                    obj[k].set({ 'stroke': '#00a0ea', 'strokeWidth': 2 / canvasZoom })
                } else if (obj[k].name == 'line3') {
                    obj[k].set({ 'stroke': '#E846AE', 'strokeWidth': 2 / canvasZoom })
                }
            }
        }

        var objectMoveX = 0
        var objectMoveY = 0

        function onObjectMoving(e) {
            if (canvasType != 'dsd' && e.target) {
                var objType = e.target.get('type')
                var obj = e.target
                const moveX = (e.e.offsetX - previousMouse.x) / canvasZoom
                const moveY = (e.e.offsetY - previousMouse.y) / canvasZoom
                previousMouse = { x: e.e.offsetX, y: e.e.offsetY }
                objectMoveX += moveX
                objectMoveY += moveY
                if (objType == 'circle') {
                    drawLinesWhenDrag(obj, objType)
                }
                if (e.target.name == 'white_frame') {
                    var objects = canvas2.getObjects()
                    // calculate new position
                    var excludeType = ['path', 'image', 'rect']
                    for (let i in objects) {
                        let obj = objects[i]
                        if (excludeType.indexOf(obj.type) == -1) {
                            obj.set({
                                left: obj.left + moveX,
                                top: obj.top + moveY,
                            })
                            obj.setCoords()
                        }
                    }
                    updateBezierLine(objectMoveX, objectMoveY, points5_1, line5_1, true)
                    updateBezierLine(objectMoveX, objectMoveY, points5_2, line5_2, true)
                    updateBezierLine(objectMoveX, objectMoveY, points5_3, line5_3, true)
                    updateQuadraticLine = true
                }

                if (e.target.name == 'line1_1' ||
                    e.target.name == 'line1_2' ||
                    e.target.name == 'line1_3' ||
                    e.target.name == 'line1_4' ||
                    e.target.name == 'line1_5' ||
                    e.target.name == 'line1_6'
                ) {
                    computeLine2()
                }

                if (e.target.name == 'line2') {
                    computeLine1To6()
                }
            }
        }

        function solveQuadraticEquation(a, b, c) {
            var res1 = (-1 * b + Math.sqrt(Math.pow(b, 2) - (4 * a * c))) / (2 * a)
            if (res1) res1 = Number(res1.toFixed(1))
            var res2 = (-1 * b - Math.sqrt(Math.pow(b, 2) - (4 * a * c))) / (2 * a)
            if (res2) res2 = Number(res2.toFixed(1))
            var result = [res1, res2]
            return result
        }


        // find control points and check if point in any quadratic bezier
        function isInBezier(points, point) {
            var initPoints = $.extend(true, [], points)
            var inBezier = false
            var initPointsAscX = $.extend(true, [], points)
            initPointsAscX.push(point)
            initPointsAscX.sort(function(a, b) {
                return a.x - b.x
            })
            var initPointsAscY = $.extend(true, [], points)
            initPointsAscY.push(point)
            initPointsAscY.sort(function(a, b) {
                return a.y - b.y
            })
            if (initPointsAscX[0].x != point.x && initPointsAscX[initPointsAscX.length - 1].x != point.x &&
                initPointsAscY[0].y != point.y && initPointsAscX[initPointsAscY.length - 1].y != point.y) { // in bezier range
                var bezierPoints = $.extend(true, [], initPoints)
                t_cubic = 0.5
                bezierPoints[1].x = Math.round((initPoints[1].x - t_cubic * t_cubic * initPoints[2].x - (1 - t_cubic) * (1 - t_cubic) * initPoints[0].x) / 2 / (1 - t_cubic) / t_cubic)
                bezierPoints[1].y = Math.round((initPoints[1].y - t_cubic * t_cubic * initPoints[2].y - (1 - t_cubic) * (1 - t_cubic) * initPoints[0].y) / 2 / (1 - t_cubic) / t_cubic)
                bezierPoints[3].x = Math.round((initPoints[3].x - t_cubic * t_cubic * initPoints[4].x - (1 - t_cubic) * (1 - t_cubic) * initPoints[2].x) / 2 / (1 - t_cubic) / t_cubic)
                bezierPoints[3].y = Math.round((initPoints[3].y - t_cubic * t_cubic * initPoints[4].y - (1 - t_cubic) * (1 - t_cubic) * initPoints[2].y) / 2 / (1 - t_cubic) / t_cubic)
                var inBezier1 = lieInBezier([bezierPoints[0], bezierPoints[1], bezierPoints[2]], point)
                var inBezier2 = lieInBezier([bezierPoints[2], bezierPoints[3], bezierPoints[4]], point)
                if (inBezier1 || inBezier2) inBezier = true
            }
            return inBezier
        }

        // check if point is in given quadratic bezier
        function lieInBezier(controlPoints, point) {
            var points_tmp = [ // increase checked points
                { x: point.x, y: point.y },
                { x: point.x, y: point.y - 1 },
                { x: point.x, y: point.y + 1 },
            ]
            var inBezier = false
            points_tmp.forEach(function(p) {
                var a_x = controlPoints[0].x + controlPoints[2].x - 2 * controlPoints[1].x
                var b_x = 2 * (controlPoints[1].x - controlPoints[2].x)
                var c_x = (controlPoints[2].x - p.x)
                var result_x = solveQuadraticEquation(a_x, b_x, c_x)
                var a_y = controlPoints[0].y + controlPoints[2].y - 2 * controlPoints[1].y
                var b_y = 2 * (controlPoints[1].y - controlPoints[2].y)
                var c_y = (controlPoints[2].y - p.y)
                var result_y = solveQuadraticEquation(a_y, b_y, c_y)
                result_x.forEach(function(x) {
                    result_y.forEach(function(y) {
                        if (x && y && x == y && 0 <= x && x <= 1) {
                            inBezier = true
                        }
                    })
                })
            })
            return inBezier
        }

        function collectPoints(line_name) {
            var circles = canvas2.getObjects('circle')
            var points = []
            let i
            for (i = 0; i < 5; i++) {
                var name = line_name + '-' + i
                var found = circles.find(function(e) {
                    return e.name == name
                })
                points.push({ x: Math.round(found.left), y: Math.round(found.top) })
            }
            return points
        }

        function onObjectMoved(e) {
            baseScalePoints[e.target.name] = {
                left: (e.target.left - white_frame.left) / white_frame.scaleX,
                top: (e.target.top - white_frame.top) / white_frame.scaleY,
            }
        }

        // compute line2 dimension based on 6 lines
        function computeLine2() {
            var lines = [line1_1, line1_2, line1_3, line1_4, line1_5, line1_6]
            var arrAscX = $.extend(true, [], lines)
            arrAscX.sort(function(a, b) {
                return a.left - b.left
            })
            var y = lines[0].top + lines[0].height * lines[0].scaleY
            line2.set({
                x1: arrAscX[0].left,
                y1: y - 2 / canvasZoom,
                x2: arrAscX[arrAscX.length - 1].left,
                y2: y - 2 / canvasZoom,
            }).setCoords()
        }

        // compute 6 lines base on line2
        function computeLine1To6() {
            var lines = [line1_1, line1_2, line1_3, line1_4, line1_5, line1_6]
            for (var k in lines) {
                lines[k].set({
                    y2: line2.top,
                }).setCoords()
                lines[k].left = baseScalePoints[lines[k].name].left * white_frame.scaleX + white_frame.left
                lines[k].top = baseScalePoints[lines[k].name].top * white_frame.scaleY + white_frame.top
                var height = line2.top - (white_frame.top - white_frame.height * white_frame.scaleY / 2)
                lines[k].height = height / lines[k].scaleY + 2 / canvasZoom
            }
        }

        function zoomGrid() {
            var objects = canvas2.getObjects()
            for (var i in objects) {
                if (objects[i].type == 'line' && objects[i].name != 'line2') {
                    if (objects[i].name == 'line3') {
                        objects[i].scaleX = white_frame.scaleX
                    } else {
                        objects[i].scaleY = white_frame.scaleY
                    }
                    objects[i].left = baseScalePoints[objects[i].name].left * white_frame.scaleX + white_frame.left
                    objects[i].top = baseScalePoints[objects[i].name].top * white_frame.scaleY + white_frame.top
                    objects[i].setCoords()
                } else if (objects[i].type == 'circle') {
                    objects[i].left = baseScalePoints[objects[i].name].left * white_frame.scaleX + white_frame.left
                    objects[i].top = baseScalePoints[objects[i].name].top * white_frame.scaleY + white_frame.top
                }
            }
            computeLine2()
            points5_1 = collectPoints('line5_1')
            updateBezierLine(0, 0, points5_1, line5_1, false)
            points5_2 = collectPoints('line5_2')
            updateBezierLine(0, 0, points5_2, line5_2, false)
            points5_3 = collectPoints('line5_3')
            updateBezierLine(0, 0, points5_3, line5_3, false)
            // canvas2.calcOffset();
            canvas2.renderAll()
        }

        document.getElementById('frame-range').oninput = function() {
            zoomFrame(this.value)
        }

        zoomFrame = (value) => {
            var zoom = (maxScaleY - minScaleY) / 100 * value + minScaleY
            white_frame.scaleX = zoom
            white_frame.scaleY = zoom
            zoomGrid()
        }

        updateScaleFrame = (value) => {
            if (hasImage) {
                var range = document.getElementById('frame-range')
                range.value = Number(range.value) + value
                var zoom = (maxScaleY - minScaleY) / 100 * range.value + minScaleY
                white_frame.scaleX = zoom
                white_frame.scaleY = zoom
                zoomGrid()

                canvas2.renderAll()
            }
        }

        /* Drawline fabric*/
        /* Mouse Capturing Work */
        var allowRemoveArea = false
        $('.upper-canvas').mouseup(function(options) {
            if (canvasType == 'dsd' && !hasEraseImg && hasImage && allowRemoveArea) {
                var pointerX = Math.round((options.pageX - canvas2._offset.left) / canvasZoom)
                var pointerY = Math.round((options.pageY - canvas2._offset.top) / canvasZoom)
                if (pts.length == 0) {
                    lastMouse.x = pointerX
                    lastMouse.y = pointerY
                } else {
                    lastMouse.x = pts[pts.length - 1].x
                    lastMouse.y = pts[pts.length - 1].y
                }
                mouse.x = pointerX
                mouse.y = pointerY
                pts.push({
                    x: mouse.x,
                    y: mouse.y,
                    mode: 'start',
                })
                onPaint()
            }
        })

        // back to canvas when image not erase and remove line
        undoLast = () => {
            if (pts.length > 0) {
                if (hasEraseImg) {
                    hasEraseImg = false
                    removeAllImage()
                    assignImageBefore()
                    imgInstance.visible = true
                    canvas2.add(imgInstance)
                    canvas2.sendToBack(imgInstance)
                    var range = document.getElementById('image-range')  // re-compute image range
                    range.value = imgInstance.scaleX * 50
                    imgTransparentControl.value = imgInstance.opacity * 100  // re-compute image opacity
                    $('#tooltip1').roundSlider('setValue', imgInstance.angle + 180) // re-compute image rotation controler
                    reverseEnableRemoveArea()
                } else {
                    var objects = canvas2.getObjects('line')
                    canvas2.remove(objects[objects.length - 1])
                }
                pts.pop()
                visibleAllLine()
                canvas2.renderAll()
                canvasChange()
            }
        }

        resizeLine = (rate) => {
            var objects = canvas2.getObjects('line')
            for (let i in objects) {
                var x = line.x2 * rate
                var y = line.y2 * rate
                line.set({ x2: x, y2: y })
            }
            for (let i in pts) {
                pts[i].x = pts[i].x * rate
                pts[i].y = pts[i].y * rate
            }
        }

        invisibleAllLine = () => {
            var objects = canvas2.getObjects('line')
            for (let i in objects) {
                objects[i].visible = false
            }
        }

        removeAllLine = () => {
            var objects = canvas2.getObjects('line')
            for (let i in objects) {
                canvas2.remove(objects[i])
            }
        }

        visibleAllLine = () => {
            var objects = canvas2.getObjects('line')
            for (let i in objects) {
                objects[i].visible = true
            }
        }

        visibleAllImage = () => {
            var objects = canvas2.getObjects('image')
            for (let i in objects) {
                objects[i].visible = true
            }
        }

        invisibleAllImage = () => {
            var objects = canvas2.getObjects('image')
            for (let i in objects) {
                objects[i].visible = false
            }
        }

        removeAllImage = () => {
            var objects = canvas2.getObjects('image')
            for (let i in objects) {
                canvas2.remove(objects[i])
            }
        }

        function createPath(ctx, clipPoints) {
            if (clipPoints && clipPoints.length > 1) {
                clipPoints.forEach((e, i) => {
                    if (i == 0) {
                        ctx.moveTo(e.x, e.y)
                    } else {
                        ctx.lineTo(e.x, e.y)
                    }
                })
            }
        }

        scanLine = (ctx, clipPoints) => {
            ctx.beginPath()
            createPath(ctx, clipPoints)
            ctx.closePath()
            /// set composite mode
            ctx.globalCompositeOperation = 'destination-out'
            ctx.fillStyle = 'blue'
            ctx.fill()
            /// reset composite mode to default
            ctx.globalCompositeOperation = 'source-over'
        }

        onPaint = () => {
            /* draw line */
            line = new fabric.Line([lastMouse.x, lastMouse.y, lastMouse.x, lastMouse.y], {
                originX: 'center',
                originY: 'center',
                stroke: 'red',
                strokeDashArray: [5, 3],
                strokeWidth: 3,
            })
            canvas2.add(line)
            line.set({ x2: mouse.x, y2: mouse.y })
            canvas2.renderAll()
        }

        // assign image before erase area to current image
        function assignImageBefore() {
            let k
            for (k in imageBeforeErase) {
                if (imageBeforeErase.hasOwnProperty(k)) {
                    if (k == 'src') {
                        imgInstance.setSrc(imageBeforeErase[k], function(img) {
                            imgInstance.setCoords()
                        })
                    } else {
                        imgInstance[k] = imageBeforeErase[k]
                    }
                }
            }
            imgInstance.setCoords()
        }

        enableRemoveArea = () => {
            if (hasImage) {
                removeAllImage()
                imageBeforeErase['angle'] = imgInstance.angle
                imageBeforeErase['scaleX'] = imgInstance.scaleX
                imageBeforeErase['scaleY'] = imgInstance.scaleY
                imageBeforeErase['left'] = imgInstance.left
                imageBeforeErase['top'] = imgInstance.top
                imageBeforeErase['flipX'] = imgInstance.flipX
                imageBeforeErase['flipY'] = imgInstance.flipY
                imageBeforeErase['opacity'] = imgInstance.opacity
                imageBeforeErase['visible'] = true

                assignImageBefore()
                canvas2.add(imgInstance)
                canvas2.sendToBack(imgInstance)
                removeAllLine()
                // pts.pop();
                canvas2.renderAll()
                pts = []
                reverseEnableRemoveArea()
                hasEraseImg = false
            }
        }

        reverseEnableRemoveArea = () => {
            allowRemoveArea = (!hasEraseImg && allowRemoveArea) ? false : true
            var removeBtn = document.getElementById('remove-area-btn')
            if (allowRemoveArea) {
                removeBtn.classList.add('active')
                imgInstance.set('selectable', false)
            } else {
                removeBtn.classList.remove('active')
                imgInstance.set('selectable', true)
            }
        }


        // remove selected area in canvas
        removeArea = () => {
            if (allowRemoveArea && pts.length > 1) {
                // $('.cutting-icon').addClass('active');
                $('#cutting-icon').click()
                imageBeforeErase['angle'] = imgInstance.angle
                imageBeforeErase['scaleX'] = imgInstance.scaleX
                imageBeforeErase['scaleY'] = imgInstance.scaleY
                imageBeforeErase['left'] = imgInstance.left
                imageBeforeErase['top'] = imgInstance.top
                imageBeforeErase['flipX'] = imgInstance.flipX
                imageBeforeErase['flipY'] = imgInstance.flipY
                imageBeforeErase['opacity'] = imgInstance.opacity
                imageBeforeErase['visible'] = true

                pts.push({
                    x: pts[0].x,
                    y: pts[0].y,
                    mode: 'end',
                })
                invisibleAllLine()
                var ptsClone = $.extend(true, [], pts)
                // rotate lines
                for (let i in ptsClone) {
                    var rotation_origin = new fabric.Point(imgInstance.left, imgInstance.top)
                    var angle_radians = fabric.util.degreesToRadians(-imgInstance.angle)
                    var start = fabric.util.rotatePoint(new fabric.Point(ptsClone[i].x, ptsClone[i].y), rotation_origin, angle_radians)
                    ptsClone[i].x = start.x
                    ptsClone[i].y = start.y
                }
                // clone canvas
                var canvasClone = document.getElementById('canvas-clone')
                var canvasCloneControl = new fabric.Canvas('canvas-clone', {
                    width: canvas2.getWidth() / canvasZoom,
                    height: canvas2.getWidth() / canvasZoom,
                    backgroundColor: 'transparent',
                    preserveObjectStacking: true,
                    selection: false,
                })
                var ctxClone = canvasClone.getContext('2d')
                canvasCloneControl.loadFromJSON(JSON.stringify(canvas2), function() {
                    // reset image
                    var imgs = canvasCloneControl.getObjects('image')
                    var imgW = imgs[0].width * imgs[0].scaleX
                    var canvasW = canvasCloneControl.getWidth()
                    var imgScale = canvasW / imgs[0].width
                    var rotation_origin = new fabric.Point(imgInstance.left, imgInstance.top)
                    var angle_radians = fabric.util.degreesToRadians(-imgInstance.angle)
                    var start = fabric.util.rotatePoint(new fabric.Point(imgInstance.oCoords.tl.x / canvasZoom, imgInstance.oCoords.tl.y / canvasZoom), rotation_origin, angle_radians)
                    var imgLeft = start.x
                    var imgTop = start.y
                    imgs[0].set({
                        'angle': 0,
                        originX: 'left',
                        originY: 'top',
                        top: 0,
                        left: 0,
                        scaleX: imgScale,
                        scaleY: imgScale,
                        opacity: 1,
                    })
                    // zoom clicked points
                    var zoom = 8000 / canvasCloneControl.getWidth()
                    var pointScale = canvasW / imgW
                    var clipPoints = $.extend(true, [], ptsClone)
                    for (let k in clipPoints) {
                        var x = (clipPoints[k].x - imgLeft) * pointScale * zoom
                        clipPoints[k].x = x
                        var y = (clipPoints[k].y - imgTop) * pointScale * zoom
                        clipPoints[k].y = y
                    }
                    canvasCloneControl.setZoom(zoom)
                    var currentWidth = canvasCloneControl.getWidth()
                    var currentHeight = canvasCloneControl.getHeight()
                    canvasCloneControl.setWidth(currentWidth * zoom)
                    canvasCloneControl.setHeight(currentHeight * zoom)
                    canvasClone.setAttribute('width', currentWidth * zoom)
                    canvasClone.setAttribute('height', currentHeight * zoom)
                    // canvasCloneControl.calcOffset();
                    imgs[0].setCoords()
                    canvasCloneControl.renderAll()
                    scanLine(ctxClone, clipPoints)
                    var imgPoints = [imgs[0].oCoords.tl, imgs[0].oCoords.bl, imgs[0].oCoords.br, imgs[0].oCoords.tr]
                    clipIt(imgPoints, canvasClone)
                    reverseEnableRemoveArea()
                    hasEraseImg = true
                })
                canvasChange()
            }
        }

        // clip the selected path to a new canvas
        function clipIt(points, canvas) {
            console.log('clipIt')
            // calculate the size of the user's clipping area
            var minX = 10000
            var minY = 10000
            var maxX = -10000
            var maxY = -10000
            for (var i = 0; i < points.length; i++) {
                var p = points[i]
                if (p.x < minX) {
                    minX = p.x
                }
                if (p.y < minY) {
                    minY = p.y
                }
                if (p.x > maxX) {
                    maxX = p.x
                }
                if (p.y > maxY) {
                    maxY = p.y
                }
            }
            var width = maxX - minX
            var height = maxY - minY
            var c1 = document.createElement('canvas')
            var cx = c1.getContext('2d')
            // resize the new canvas to the size of the clipping area
            c1.width = imageOriginDimension.width
            c1.height = imageOriginDimension.height
            // draw the clipped image from the main canvas to the new canvas
            cx.drawImage(canvas, minX, minY, width, height, 0, 0, imageOriginDimension.width, imageOriginDimension.height)
            fabric.Image.fromURL(c1.toDataURL('image/png'), function(img2) {
                // add image to displayed canvas
                imgInstance = img2.set({
                    originX: 'center',
                    originY: 'center',
                    // selectable: false,
                    hasControls: false,
                    name: 'background',
                    hasBorders: false,
                    angle: imgInstance.angle,
                    left: imgInstance.left,
                    top: imgInstance.top,
                    scaleX: imgInstance.scaleX,
                    scaleY: imgInstance.scaleY,
                    opacity: imgTransparentControl.value / 100,
                })
                invisibleAllImage()
                canvas2.add(imgInstance)
                canvas2.sendToBack(imgInstance)
                canvas2.renderAll()
                // remove old img
                var imgs = canvas2.getObjects('image')
                canvas2.remove(imgs[1])
                // $('.cutting-icon').removeClass('active');
                $('#cutting-icon').click()
            })
            // clear the previous points
            // points.length = 0;
        }

        // save canvas to json
        saveCanvas = (action) => {
            console.log('saveCanvas', action)

            var canvasJson = canvas2.toJSON(stateProperties)
            var canvasImgBase = ''
            var canvasImgBefore = ''
            var canvasImgDemo = ''
            for (let i in canvasJson.objects) {
                if (canvasJson.objects[i].name == 'background') {
                    canvasImgBase = canvasJson.objects[i].src
                    delete canvasJson.objects[i].src
                }
            }
            if (canvasType == 'dsd' && hasVideo) {
                canvasImgDemo = getCanvasDemo()
            } else if (canvasType == 'dsd' && !hasVideo) {
                canvasImgDemo = canvas.toDataURL('image/png')
            } else { // smile
                white_frame.hasBorders = false
                white_frame.hasControls = false
                canvas2.renderAll()
                canvasImgDemo = canvas.toDataURL('image/png')
                white_frame.hasControls = true
                white_frame.hasBorders = true
                canvas2.renderAll()
            }
            console.log(canvas2)
            var imgBefore = { src: '' }
            if (hasImage && JSON.stringify(imageBeforeErase) != '{}' && !imageBeforeErase.src) {
                imgBefore = $.extend({}, imageBeforeErase.toJSON(stateProperties))
            } else if (hasImage && JSON.stringify(imageBeforeErase) != '{}' && imageBeforeErase.src) {
                imgBefore = $.extend({}, imageBeforeErase)
            }
            canvasImgBefore = imgBefore.src
            delete imgBefore.src
            var tooltipValue = $('#tooltip1').roundSlider('option', 'value')
            var result = {}
            var output = {
                canvas: canvasJson,
                canvasType: canvasType,
                canvasWidth: canvas2.getWidth() / canvasZoom,
                canvasHeight: canvas2.getHeight() / canvasZoom,
                imageRange: imageRange.value,
                tooltipValue: tooltipValue,
                hasImage: hasImage,
            }
            if (canvasType == 'smile') {
                var frameRange = document.getElementById('frame-range').value
                var smile = {
                    baseScalePoints: baseScalePoints,
                    baseGrid: baseGrid,
                    frameRange: frameRange,
                    maxScaleX: maxScaleX,
                    maxScaleY: maxScaleY,
                    minScaleX: minScaleX,
                    minScaleY: minScaleY,
                    points5_1: points5_1,
                    points5_2: points5_2,
                    points5_3: points5_3,
                }
                result = Object.assign(output, smile)
            } else {
                var dsd = {
                    videoZoom: videoZoom.value,
                    videoTimeRange: videoTimeRange.value,
                    videoDuration: canvasVideo.duration,
                    hasVideo: hasVideo,
                    videoZoomRate: videoZoomRate,
                    mouse: mouse,
                    lastMouse: lastMouse,
                    pts: pts,
                    hasEraseImg: hasEraseImg,
                    imageBeforeErase: imgBefore,
                    imageOriginDimension: imageOriginDimension,
                }
                result = Object.assign(output, dsd)
            }
            if (action == 'save') {
                window['canvasSave'] = JSON.stringify(result)
                window['canvasImgBaseSave'] = canvasImgBase
                window['canvasImgBeforeSave'] = canvasImgBefore
                window['canvasImgDemoSave'] = canvasImgDemo
            } else if (action == 'copy') {
                window['canvasCopy'] = JSON.stringify(result)
                window['canvasImgBaseCopy'] = canvasImgBase
                window['canvasImgBeforeCopy'] = canvasImgBefore
                window['canvasImgDemoCopy'] = canvasImgDemo
            }
            if (canvasVideo.firstChild) {
                let videoSrc = canvasVideo.firstChild.src
                if (videoSrc.indexOf('amazonaws') != -1 && action == 'save') {
                    window['canvasVideoSave'] = videoSrc
                } else if (videoSrc.indexOf('amazonaws') != -1 && action == 'copy') {
                    window['canvasVideoCopy'] = videoSrc
                }
            }
        }

        // get canvas demonstration
        function getCanvasDemo() {
            console.log('getCanvasDemo')
            var canvasDownload = cloneCanvasRatio()
            const canvasWidth = canvasDownload.getWidth()
            const canvasHeight = canvasDownload.getHeight()

            var demo = ''
            canvasDownload.backgroundColor = '#e8e8e8'
            canvasDownload.renderAll()
            var videoWidth = Math.floor(canvasWidth / 2 * videoZoomRate)
            var scaleRate = videoWidth / canvasVideo.videoWidth / canvasZoom
            let pd = canvasHeight / canvasZoom
            console.log('top', (pd - canvasVideo.videoHeight * scaleRate) - (pd * 0.1))

            var video = new fabric.Image(canvasVideo, {
                width: canvasVideo.videoWidth,
                height: canvasVideo.videoHeight,
                originX: 'center',
                originY: 'top',
                selectable: false,
                hasControls: false,
                hasBorders: false,
                scaleX: scaleRate,
                scaleY: scaleRate,
                left: canvasWidth / 2 / canvasZoom,
                top: (pd - canvasVideo.videoHeight * scaleRate) - (pd * 0.1),
            })
            canvasVideo.style.visibility = 'hidden'
            canvasDownload.add(video)
            canvasDownload.sendToBack(video)
            // video.setCoords();
            canvasDownload.renderAll()
            console.log('getCanvasDemo', canvasDownload, video)
            demo = canvas.toDataURL('image/png')
            console.log('getCanvasDemo base64', demo)

            canvasDownload.remove(canvasDownload.getObjects('image')[0])
            canvasVideo.style.visibility = 'visible'
            canvasDownload.backgroundColor = 'transparent'
            canvasDownload.renderAll()
            return demo
        }

        // getCanvasJson = () => {
        //     var file = $('#canvasJson').prop('files')[0];
        //     var myReader = new FileReader();
        //     myReader.onload = () => {
        //         window.localStorage.setItem('canvas', myReader.result);
        //     }
        //     myReader.readAsText(file);
        // }

        updateCanvas = () => {
            window['canvasVideoCopy'] = ''
            hasImage = false
            if (canvasType != 'dsd') {
                resetCanvas()
            } else {
                hasVideo = false
                pts = []
                allowRemoveArea = false
                $('#remove-area-btn').removeClass('active')
                canvas2.clear()
            }
            resetRange()
            canvasZoom = 1
            canvas2.setZoom(canvasZoom)
            canvas2.renderAll()
            var canvas = window['canvas']
            if (canvas && canvas != 'undefined') {
                visibleCanvas(false)
                var canvasImgBase = window['canvasImgBase']
                var canvasImgBefore = window['canvasImgBefore']
                restoreCanvas(canvas, canvasImgBase, canvasImgBefore)
            }
        }

        // reset all range and slider
        function resetRange() {
            imageRange.value = 50
            videoZoom.value = 50
            videoTimeRange.value = 0
            $('#tooltip1').roundSlider('setValue', 180)
            // canvasVideo.innerHTML = '';
            canvasVideo.load()
        }

        var canvasZoom = 1

        // restore canvas from stored data
        function restoreCanvas(canvasJson, canvasImgBase, canvasImgBefore) {
            var canvasBackup = JSON.parse(canvasJson)
            hasImage = canvasBackup.hasImage
            var canvasTmp = canvasBackup.canvas
            if (canvasImgBase) {
                hasImage = true
                for (let i in canvasTmp.objects) {
                    if (canvasTmp.objects[i].name == 'background') {
                        canvasTmp.objects[i].src = canvasImgBase
                    }
                }
            }
            canvasZoom = $('#bd-wrapper').width() / canvasBackup.canvasWidth
            canvasBaseWidth = canvasBackup.canvasWidth
            canvasBaseHeight = canvasBackup.canvasHeight
            canvasType = canvasBackup.canvasType
            imageRange.value = canvasBackup.imageRange
            canvas2.loadFromJSON(JSON.stringify(canvasTmp), function() {
                if (hasImage) {
                    imgInstance = canvas2.getObjects('image')[0]
                    imgTransparentControl.value = imgInstance.opacity * 100
                }
                if (canvasType == 'smile') {
                    var paths = canvas2.getObjects('path')
                    for (let i in paths) {
                        canvas2.remove(paths[i])
                    }
                    restoreFrame(canvas2.getObjects())
                    restoreBezierLines(canvas2, canvasBackup)
                    resetLineDimension()
                } else {
                    disableLineSelect(canvas2.getObjects('line'))
                }
                canvas2.setZoom(canvasZoom)
                canvas2.setWidth(canvasBackup.canvasWidth * canvasZoom)
                canvas2.setHeight(getHeightRatio(canvasBackup.canvasWidth * canvasZoom))
                canvas.setAttribute('width', canvasBackup.canvasWidth * canvasZoom)
                canvas.setAttribute('height', getHeightRatio(canvasBackup.canvasWidth * canvasZoom))
                // canvas2.calcOffset();
                canvas2.renderAll()
                visibleCanvas(true)
                checkImgFunctions(hasImage)
            })
            $('#tooltip1').roundSlider('setValue', canvasBackup.tooltipValue)
            if (canvasType == 'smile') {
                baseScalePoints = canvasBackup.baseScalePoints
                baseGrid = canvasBackup.baseGrid
                document.getElementById('frame-range').value = canvasBackup.frameRange
                maxScaleX = canvasBackup.maxScaleX
                maxScaleY = canvasBackup.maxScaleY
                minScaleX = canvasBackup.minScaleX
                minScaleY = canvasBackup.minScaleY
            } else {
                canvasBackup.imageBeforeErase.src = canvasImgBase ? canvasImgBefore : ''
                mouse = canvasBackup.mouse
                lastMouse = canvasBackup.lastMouse
                pts = canvasBackup.pts
                hasEraseImg = canvasBackup.hasEraseImg
                if (canvasImgBase) {
                    imageBeforeErase = canvasBackup.imageBeforeErase
                }
                imageOriginDimension = canvasBackup.imageOriginDimension
                hasVideo = canvasBackup.hasVideo
                videoZoom.value = canvasBackup.videoZoom
                zoomVideo(videoZoom.value)
                videoTimeRange.value = canvasBackup.videoTimeRange
                var time = canvasBackup.videoDuration * (videoTimeRange.value / 100)
                canvasVideo.currentTime = time
                videoZoomRate = canvasBackup.videoZoomRate
            }
            checkVideoFunctions(hasVideo)
            window['canvasChange'] = false
            window['canvasVideo'] = ''
        }

        // update lines and white_frame
        function restoreFrame(frame) {
            var tmp = {}
            frame.forEach(function(e) {
                tmp[e.name] = e
            })
            white_frame = tmp['white_frame']
            white_frame.on('scaling', scaleFrame)
            line1_1 = tmp['line1_1']
            line1_2 = tmp['line1_2']
            line1_3 = tmp['line1_3']
            line1_4 = tmp['line1_4']
            line1_5 = tmp['line1_5']
            line1_6 = tmp['line1_6']
            line2 = tmp['line2']
            line3 = tmp['line3']
            line4_1 = tmp['line4_1']
            line4_2 = tmp['line4_2']
            line4_3 = tmp['line4_3']
        }

        function resetCanvas() {
            canvas2.setZoom(1)
            canvas2.loadFromJSON(canvasOrigin, function() {
                var paths = canvas2.getObjects('path')
                for (let i in paths) {
                    canvas2.remove(paths[i])
                }
                restoreFrame(canvas2.getObjects())
                var points = {
                    points5_1: $.extend(true, [], baseGrid.points5_1),
                    points5_2: $.extend(true, [], baseGrid.points5_2),
                    points5_3: $.extend(true, [], baseGrid.points5_3),
                }
                restoreBezierLines(canvas2, points)
                baseScalePoints = $.extend(true, {}, originBaseScalePoints)
                canvas2.renderAll()
            })
        }

        function visibleCanvas(show) {
            if (!show) {
                canvas.style.opacity = 0
            } else {
                $('#canvas-item').animate({ opacity: '1' }, 400)
            }
        }

        // add bezier lines based on points
        function restoreBezierLines(canvas, canvasBackup) {
            var objects = canvas.getObjects()
            var pathPos = objects.findIndex(function(e) {
                return e.type == 'circle'
            })
            canvas.add(line5_1)
            canvas.moveTo(line5_1, pathPos)
            canvas.add(line5_2)
            canvas.moveTo(line5_2, pathPos)
            canvas.add(line5_3)
            canvas.moveTo(line5_3, pathPos)
            points5_1 = canvasBackup.points5_1
            points5_2 = canvasBackup.points5_2
            points5_3 = canvasBackup.points5_3
            updateBezierLine(0, 0, points5_1, line5_1, false)
            updateBezierLine(0, 0, points5_2, line5_2, false)
            updateBezierLine(0, 0, points5_3, line5_3, false)
        }

        function disableLineSelect(obj) {
            for (let k in obj) {
                obj[k].selectable = false,
                    obj[k].hasControls = false,
                    obj[k].hasBorders = false
            }
        }

        function getHeightRatio(width) {
            return width * 720 / 1280
        }

        function dispose() {
            console.log('dispose')
            if (!!canvas) {
                canvas.dispose()
                canvas2.dispose()
                // can delete container dom out side (with is more efficient) but run time won't allow??
                canvas = null
                console.log('dispose canvas complete')
            }
            $(window).off('resize')
        }

        return {
            canvas: canvas2,
        }
    }

    function getHeightRatio(width) {
        return width * 720 / 1280
    }

    this.disposeCanvas = function(canvas) {
        if (!!canvas) {
            canvas.dispose()
            // can delete container dom out side (with is more efficient) but run time won't allow??
            canvas = null
            console.log('dispose canvas complete')
        }
    }
}(jQuery, window))




// WEBPACK FOOTER //
// src/assets/js/image-control.js